module.exports = __webpack_public_path__ + "img/subscriptions-advert.6189645.jpg";